<template>
  <div>
    <el-card class="mb10">
      <el-form
        ref="searchFormRef"
        :model="queryForm"
        label-position="top"
        size="small"
      >
        <el-row :gutter="10">
          <el-col :span="8">
            <!-- 创建时间 -->
            <el-form-item
              :label="$t('GlobalSetObj.CreationTime')"
              prop="params.dateRange"
            >
              <el-date-picker
                v-model="queryForm.params.dateRange"
                type="datetimerange"
                range-separator="-"
                value-format="yyyy-MM-dd HH:mm:ss"
                :default-time="['00:00:00', '23:59:59']"
                :start-placeholder="$t('GlobalSetObj.startDate')"
                :end-placeholder="$t('GlobalSetObj.endDate')"
                style="width: 100%;"
              />
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <!-- 航空公司 -->
            <el-form-item :label="$t('mdfeTranslate.Airline')">
              <el-input
                v-model="queryForm.params.airlineName"
                :placeholder="$t('GlobalSetObj.pleaseInput')"
                clearable
              />
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <!-- 状态 -->
            <el-form-item :label="$t('collectionCenter.stateZT')">
              <el-select
                v-model="queryForm.params.status"
                :placeholder="$t('GlobalSetObj.all')"
                style="width: 100%"
                clearable
              >
                <el-option key="1" :label="$t('GlobalSetObj.enable')" :value="1" />
                <el-option key="0" :label="$t('GlobalSetObj.disable')" :value="0" />
                <!--                <el-option key="2" :label="$t('collectionCenter.Stored')" :value="2" />-->
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="4">
            <el-form-item style="margin-bottom: 0;">
              <div style="margin-top: 27px;">
                <!-- 搜索 -->
                <el-button
                  icon="el-icon-search" size="small" type="primary"
                  @click="searchTableData"
                >{{ $t('operationCenter.Procurar') }}
                </el-button>
                <!-- 重置 -->
                <el-button icon="el-icon-refresh" size="small" @click="queryFormReset">{{ $t('operationCenter.reset') }}
                </el-button>
              </div>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </el-card>
    <el-card>
      <div>
        <el-button
          v-permit:remove="'btn:invoiceCenter:pushConfiguration:add'"
          type="primary"
          size="small"
          @click="addConfiguration"
        >{{ $t('mdfeTranslate.AddConfiguration') }}</el-button>
      </div>
      <div style="margin-top: 10px;">
        <table-column
          :key="tableKey"
          :table-data="tableData"
          @editView="addConfiguration"
          @closeUpdate="closeDrawerWindow"
        />
        <div class="pagination">
          <!-- 分页工具 -->
          <el-pagination
            :current-page.sync="queryForm.pageNumber"
            :page-size.sync="queryForm.pageSize"
            :page-sizes="[10, 20, 50, 100]"
            :total="total"
            background
            layout="total, sizes, prev, pager, next, jumper"
            style="margin: 10px 0"
            @current-change="handleCurrentChange"
            @size-change="handleSizeChange"
          />
        </div>
      </div>
    </el-card>
    <el-drawer
      :title="$t('mdfeTranslate.AddConfiguration')"
      :visible.sync="showDrawerWindow"
      direction="ltr"
      size="80%"
    >
      <form-cmp
        :key="formKey"
        :form-data="formData"
        :form-type="formType"
        @closeUpdate="closeDrawerWindow"
      />
    </el-drawer>
  </div>
</template>
<script>
import tableColumn from './cmp/tableColumn.vue';
import formCmp from './cmp/form.vue';
import { airlinePushConfigDetail, airlinePushConfigPageQuery } from '@/api/invoiceCenter';
// import dayjs from 'dayjs';
export default {
  name: 'PushConfiguration',
  components: {
    tableColumn,
    formCmp
  },
  data() {
    return {
      queryForm: {
        pageSize: 10,
        pageNumber: 1,
        params: {
          dateRange: [],
          airlineName: null,
          status: null
        }
      },
      total: 0,
      tableData: [],
      tableKey: new Date().getTime(),
      formKey: new Date().getTime(),
      showDrawerWindow: false,
      formData: {
        basicConfig: {
          airlineName: null,
          baseUrl: null,
          email: null,
          senha: null
        },
        transportConfig: {
          formaPagamento: 'PX',
          contaCorrente: '11605535000102',
          tipoEntrega: 'Aeroporto',
          siglaServico: 'STANDARD',
          produtoNatureza: '',
          codigoProduto: 'NOR',
          codigoManuseio: 'NOR',
          taxaColeta: false
        }
      },
      formType: 0
    };
  },
  created() {
    // const currentDate = dayjs().format('YYYY-MM-DD');
    // this.queryForm.params.dateRange = [currentDate + ' 00:00:00', currentDate + ' 23:59:59'];
    this.searchTableData();
  },
  methods: {
    // 搜索
    searchTableData() {
      const params = {
        pageSize: this.queryForm.pageSize,
        pageNumber: this.queryForm.pageNumber,
        params: {
          startTime: null,
          endTime: null,
          airlineName: this.queryForm.params.airlineName,
          status: this.queryForm.params.status
        }
      };
      if (this.queryForm.params.dateRange && this.queryForm.params.dateRange.length > 1) {
        params.params.startTime = this.queryForm.params.dateRange[0];
        params.params.endTime = this.queryForm.params.dateRange[1];
      }
      airlinePushConfigPageQuery(params).then(res => {
        if (res.code === 200) {
          this.tableData = res.data.records;
          this.total = res.data.total;
          this.tableKey = new Date().getTime();
        }
      });
    },
    // 重置
    queryFormReset() {
      this.queryForm.params.dateRange = [];
      this.queryForm.params.airlineName = null;
      this.queryForm.params.status = null;
      this.searchTableData();
    },
    // 每页显示数量变化
    handleSizeChange(val) {
      this.queryForm.pageSize = val;
      this.queryForm.pageNumber = 1;
      this.searchTableData();
    },
    // 翻页
    handleCurrentChange(val) {
      this.queryForm.pageNumber = val;
      this.searchTableData();
    },
    // 新增配置
    addConfiguration(data = null, type = 0) {
      this.formType = type;
      if (type !== 0) {
        airlinePushConfigDetail(data.configCode).then(res => {
          if (res.code === 200) {
            const dataForm = JSON.parse(res.data.configValue);
            console.log(dataForm, '====dataForm');
            this.formData = {
              basicConfig: {
                airlineName: res.data.airlineName,
                configCode: res.data.configCode,
                baseUrl: dataForm.basicConfig.baseUrl,
                email: dataForm.basicConfig.email,
                senha: dataForm.basicConfig.senha
              },
              transportConfig: {
                formaPagamento: dataForm.transportConfig.formaPagamento,
                contaCorrente: dataForm.transportConfig.contaCorrente,
                tipoEntrega: dataForm.transportConfig.tipoEntrega,
                siglaServico: dataForm.transportConfig.siglaServico,
                codigoProduto: dataForm.transportConfig.codigoProduto,
                produtoNatureza: dataForm.transportConfig.produtoNatureza,
                codigoManuseio: dataForm.transportConfig.codigoManuseio,
                taxaColeta: dataForm.transportConfig.taxaColeta
              }
            };
            this.showDrawerWindow = true;
            this.formKey = new Date().getTime();
          }
        });
      } else {
        this.formData = {
          basicConfig: {
            airlineName: null,
            baseUrl: null,
            email: null,
            senha: null
          },
          transportConfig: {
            formaPagamento: 'PX',
            contaCorrente: '11605535000102',
            tipoEntrega: 'Aeroporto',
            siglaServico: 'STANDARD',
            produtoNatureza: '',
            codigoProduto: 'NOR',
            codigoManuseio: 'NOR',
            taxaColeta: false
          }
        };
        this.showDrawerWindow = true;
        this.formKey = new Date().getTime();
      }
    },
    // 关闭抽屉
    closeDrawerWindow(update) {
      // 是否更新数据 update：true 更新数据，false 不更新数据
      if (update) {
        this.searchTableData();
      }
      this.showDrawerWindow = false;
    }
  }
};
</script>

<style scoped>

</style>
